/**
 * 创建人：但志强
 * 时间：2019-6-11
 * 描述：自定义布尔值 
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

/**
 * 自定义布尔值转换
 * @example <td [innerHTML]="data.isPublish | boolState:'已发布':'未发布'"></td>
 */
@Pipe({
  name: 'boolState'
})
export class BoolStatePipe implements PipeTransform {
     //获取当前dom节点
    constructor(private dom: DomSanitizer ){}

    /**
     * 管道的初始化方法
     * @param value 传入的数据  true 或者f alse
     * @param isTrue  为ture时显示的数据
     * @param isFalse  为false时显示的数据
     * @param color  为false时显示的数据的颜色，不传默认是红色，传值'state-default'就是灰色
     */
    transform(value: boolean | number, isTrue: string, isFalse: string, color?: string): any {
      if(+value){
        //表面该HTML是可信赖的
        return this.dom.bypassSecurityTrustHtml(`<span class="state-success">${isTrue}</span>`);
      } else {
        if(color && color == 'state-default'){
          return this.dom.bypassSecurityTrustHtml(`<span class="${color}">${isFalse}</span>`);
        } else{
          return this.dom.bypassSecurityTrustHtml(`<span class="state-error">${isFalse}</span>`);
        }
        
      }
    }

}
//前台写法
//<td [innerHTML]="data.isPublish | boolState:'已发布':'未发布'"></td>  
//<td [innerHTML]="data.isPublish | boolState:'已发布':'未发布':'state-default'"></td>